module.exports = __webpack_public_path__ + "img/setIcon4.62a78bb7.png";